import { TFunction } from '@mint-lib/i18n';
import { z } from 'zod';

import { OptionItemSchema } from './shared.js';

export const getNewRequestFormSchema = (t: TFunction) => {
  return z.object({
    flowId: z.string().min(1, t('Required field')),
    carbonCopyEmails: z.array(OptionItemSchema),
    comments: z.string(),
  });
};

export type NewRequestFormValues = z.infer<
  ReturnType<typeof getNewRequestFormSchema>
>;
